<template>
  <div class="container">
    <div style="width: 100%; margin: 0 auto; margin-bottom: 95px">
      <el-card class="box-card" style="margin-top: 95px">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row>
            <el-form-item label="小区名称" class="re-2">
              <el-autocomplete
                v-if="is_company == 1"
                class="inline-input"
                v-model="form.xqname"
                :fetch-suggestions="querySearch"
                placeholder="请输入小区名称"
                :trigger-on-focus="false"
                @select="handleSelect"
              ></el-autocomplete>
              <el-input
                v-else
                v-model="form.xqname"
                placeholder="请输入小区名称"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="楼号" class="re-11">
                <el-input
                  v-model="form.lounumber"
                  placeholder="几号楼"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="房号" class="re-11">
                <el-input
                  v-model="form.haonumber"
                  placeholder="房间号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="房源户型" class="re-4">
                <el-select
                  v-model="form.regionRoom"
                  class="re-3"
                  placeholder="室"
                >
                  <el-option label="1室" value="1"></el-option>
                  <el-option label="2室" value="2"></el-option>
                  <el-option label="3室" value="3"></el-option>
                  <el-option label="4室" value="4"></el-option>
                  <el-option label="5室" value="5"></el-option>
                  <el-option label="6室" value="6"></el-option>
                  <el-option label="7室" value="7"></el-option>
                  <el-option label="8室" value="8"></el-option>
                  <el-option label="9室" value="9"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" class="re-5">
                <el-select
                  v-model="form.regionTing"
                  class="re-3"
                  placeholder="厅"
                >
                  <el-option label="0厅" value="0"></el-option>
                  <el-option label="1厅" value="1"></el-option>
                  <el-option label="2厅" value="2"></el-option>
                  <el-option label="3厅" value="3"></el-option>
                  <el-option label="4厅" value="4"></el-option>
                  <el-option label="5厅" value="5"></el-option>
                  <el-option label="6厅" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" class="re-6">
                <el-select
                  v-model="form.regionWei"
                  class="re-3"
                  placeholder="卫"
                >
                  <el-option label="1卫" value="1"></el-option>
                  <el-option label="2卫" value="2"></el-option>
                  <el-option label="3卫" value="3"></el-option>
                  <el-option label="4卫" value="4"></el-option>
                  <el-option label="5卫" value="5"></el-option>
                  <el-option label="6卫" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="付款方式" class="re-7">
                <el-select
                  v-model="form.regionYajing"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option label="押一" value="押一"></el-option>
                  <el-option label="押二" value="押二"></el-option>
                  <el-option label="押三" value="押三"></el-option>
                  <el-option label="押四" value="押四"></el-option>
                  <el-option label="押五" value="押五"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" class="re-8">
                <el-select
                  v-model="form.regionZujing"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option label="付一" value="付一"></el-option>
                  <el-option label="付二" value="付二"></el-option>
                  <el-option label="付三" value="付三"></el-option>
                  <el-option label="付四" value="付四"></el-option>
                  <el-option label="付五" value="付五"></el-option>
                  <el-option label="半年付" value="半年付"></el-option>
                  <el-option label="一年付" value="一年付"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="租赁类型" class="re-7">
                <el-select
                  v-model="form.rentType"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, key) in form.rentTypeList"
                    :label="item"
                    v-bind:key="key"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="房源类型:" class="re-9">
            <el-row :gutter="168">
              <el-radio-group v-model="form.radioHouseType" class="re-10">
                <el-col
                  :span="4"
                  v-for="(item, key) in form.radioHouseTypeList"
                  v-bind:key="key"
                >
                  <el-radio :label="item.id">{{ item.name }}</el-radio>
                </el-col>
              </el-radio-group>
            </el-row>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="所在区域" class="re-7">
                <el-cascader
                  ref="cascader"
                  v-model="form.quyu"
                  placeholder="试试搜索"
                  :options="form.quyuList"
                  size="medium"
                  filterable
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="所在区域" class="re-7">
                <el-select
                  v-model="form.quyu"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, key) in form.quyuList"
                    :label="item.name"
                    v-bind:key="key"
                    :value="item.areaid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="地铁线" class="re-7">
                <el-select
                  v-model="form.subway"
                  class="re-3"
                  placeholder="请选择"
                >
                  <el-option label="1号线" value="1"></el-option>
                  <el-option label="2号线" value="2"></el-option>
                  <el-option label="3号线" value="3"></el-option>
                  <el-option label="4号线" value="4"></el-option>
                  <el-option label="5号线" value="5"></el-option>
                  <el-option label="6号线" value="6"></el-option>
                  <el-option label="7号线" value="7"></el-option>
                  <el-option label="8号线" value="8"></el-option>
                  <el-option label="9号线" value="9"></el-option>
                  <el-option label="10号线" value="10"></el-option>
                  <el-option label="11号线" value="11"></el-option>
                  <el-option label="12号线" value="12"></el-option>
                  <el-option label="13号线" value="13"></el-option>
                  <el-option label="14号线" value="14"></el-option>
                  <el-option label="15号线" value="15"></el-option>
                  <el-option label="16号线" value="16"></el-option>
                  <el-option label="17号线" value="17"></el-option>
                  <el-option label="18号线" value="18"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row v-if="options.length > 0">
            <el-col :span="8">
              <el-form-item label="地铁站点" class="re-7">
                <el-cascader
                  v-model="form.lineStation"
                  placeholder="试试搜索"
                  :options="options"
                  filterable
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="面积" class="re-12">
              <el-input
                v-model="form.housesize"
                type="number"
                placeholder="平方米"
                oninput="value = value.replace(/[^\d]/g, '').replace(/^0+(\d)/, '$1')"
              ></el-input>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="详细地址" class="re-2">
              <el-input
                v-model="form.address"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-row> -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="房屋租金" class="re-11">
                <el-input
                  v-model="form.rent"
                  type="number"
                  placeholder="元"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="佣金比例" class="re-11">
                <el-input
                  v-model="form.rentbai"
                  type="number"
                  placeholder="百分比"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="房屋设施:" class="re-9">
            <el-row :gutter="128">
              <el-checkbox-group
                v-model="form.sheshi"
                @change="sheshiList"
                class="re-10"
              >
                <el-col
                  :span="4"
                  v-for="(item, key) in form.sheshiList"
                  v-bind:key="key"
                >
                  <el-checkbox :label="item.id" name="type">{{
                    item.name
                  }}</el-checkbox>
                </el-col>
              </el-checkbox-group>
            </el-row>
          </el-form-item>
          <el-form-item v-if="is_company == 1" label="发布属性" class="re-2">
            <template>
              <el-radio-group v-model="form.radio" @change="radioChange">
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">秒租</el-radio>
                <el-radio :label="3">私盘</el-radio>
                <el-radio :label="4">二房东</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-row>
            <el-form-item label="房东姓名" class="re-2">
              <el-input
                v-model="form.fangdxingming"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-form-item label="房东电话" class="re-2">
              <el-input
                v-model="form.fangdphone"
                type="number"
                placeholder="请输入电话"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <div
              class="el-form-item__label"
              style="margin-left: 10px; margin-bottom: 5px"
            >
              简介:
            </div>
            <el-form-item label="" class="re-2copy">
              <el-input
                type="textarea"
                :rows="7"
                placeholder="关于该房屋的其它信息"
                v-model="form.jianjie"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="上传图片:" class="re-13"></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="" class="re-14">
              <el-upload
                action="test"
                ref="upload"
                list-type="picture-card"
                name="UploadForm[file][]"
                :multiple="true"
                :limit="20"
                accept=".jpg, .jpeg, .png, .gif, .bmp"
                :auto-upload="true"
                :http-request="handleUpload"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-button type="primary" round @click="submitUpload" class="sdf"
              >上传</el-button
            >
          </el-row>
        </el-form>
      </el-card>
    </div>

    <!-- 模态框（Modal） -->
    <div
      class="modal fade"
      id="myModaltwo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="background: #000; margin-top: 172px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              style="color: #fff; opacity: 1"
            >
              &times;
            </button>
            <h4
              v-if="is_company == 1"
              class="modal-title"
              id="myModalLabel"
              style="color: #fff"
            >
              您已发布成功
            </h4>
            <h4
              v-else
              class="modal-title"
              id="myModalLabel"
              style="color: #fff"
            >
              感谢您的发布，我们正在审核您的房源
            </h4>
          </div>
          <div class="modal-body" v-if="is_company == 1">
            <img src="../assets/images/checking.svg" width="155px;" />
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal -->
    </div>
  </div>
</template>
<script>
import https from "../http.js";
import qs from "qs";
import { getLoaction } from "../location.js";
import { contains } from "jquery";
export default {
  data() {
    return {
      // 默认不显示，默认二房东
      is_company: "",
      // is_showbtn:false,
      restaurants: [],
      form: {
        radio: "1",
        xqname: "",
        lounumber: "",
        haonumber: "",
        regionRoom: "",
        regionTing: "",
        regionWei: "",
        regionYajing: "",
        regionZujing: "",
        radioHouseType: "",
        address: "",
        rent: "",
        quyu: [],
        rentbai: "",
        sheshi: [],
        subway: "",
        subwaystation: "",
        lineStation: [],
        imgurldata: "",
        rentType: "",
        rentTypeList: ["长租", "短租"],
        quyuList: [],
        radioHouseTypeList: [],
        sheshiList: [],
        rent: "",
        jianjie: "",
        fangdxingming: "",
        fangdphone: "",
        housesize: "",
        area: "",
        province: "",
        city: "",
        regional: "",
        location_address: "",
        longitude: "",
        latitude: "",
      },
      files: [],
      options: [],
    };
  },

  created: function() {
    this.form.radio = 4;
    getLoaction.getRralTimeLocationAddress().then((locationData) => {
      console.log(locationData);
      this.form.province = locationData.ad_info.province;
      this.form.city = locationData.ad_info.city;
      if (locationData.ad_info.province == "上海市") {
        this.form.regional = locationData.ad_info.district.substring(0, 2);
        //因为数据库上海城市的区域是简化的，所以这里定位给的区域也要简化。不然和数据默认对应不上
      } else {
        this.form.regional = locationData.ad_info.district;
      }
      this.form.location_address =
        locationData.ad_info.province +
        locationData.ad_info.city +
        locationData.ad_info.district;
      // this.form.longitude = locationData.location.lng;
      // this.form.latitude = locationData.location.lat;
      this.form.quyu.push(this.form.province);
      this.form.quyu.push(this.form.city);
      this.form.quyu.push(this.form.regional);
      this.form.area = locationData.ad_info.adcode;

      this.getInitData();
      this.getLineStation();
    });

    // var phoned = sessionStorage.getItem("phone");
    // var usenamedd = sessionStorage.getItem("username");
    // var phoned = this.$cookies.get("phone");
    // var usenamedd = this.$cookies.get("username");

    this.form.fangdphone = this.$cookies.get("phone");
    this.form.fangdxingming = this.$cookies.get("username");
  },

  methods: {
    getInitData() {
      var param = {
        user_id: this.$cookies.get("userid"),
        city: this.form.city,
      };
      https
        .fetchPost("/releases-house/releases-house", qs.stringify(param))
        .then((data) => {
          // this.form.quyuList = data.data.area;
          this.form.radioHouseTypeList = data.data.house_type;
          this.form.sheshiList = data.data.facilitise;
          this.is_company = data.data.is_company;
          // this.options = data.data.line_station;
          //设置默认选中
          let sehshiCheck = this.form.sheshiList.filter((item) => {
            return item.is_default_check == true;
          });
          this.form.sheshi = sehshiCheck.map((item) => {
            return item.id;
          });
          this.form.quyuList = data.data.province;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getLineStation() {
      var param = {
        city: this.form.city,
      };
      https
        .fetchPost("/wechat-index/get-line-station", qs.stringify(param))
        .then((res) => {
          this.options = res.data.data;
          if (res.data.data.length == 0) {
            this.form.lineStation = [null, null];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleChange(value) {
      console.log(value);
      let nodesInfo = this.$refs["cascader"].getCheckedNodes();
      // console.log(nodesInfo);
      // this.form.latitude = "";
      // this.form.longitude = "";
      this.form.location_address = value[0] + value[1] + value[2];
      this.form.area = nodesInfo[0].data.areaid;
      this.form.province = value[0];
      this.form.city = value[1];
      this.form.regional = value[2];

      console.log(this.form.city);
      this.getLineStation();
      // console.log(this.form.area);
    },
    // 设施
    sheshiList(e) {
      console.log(e);
    },
    querySearch(queryString, cb) {
      var param = {
        keywords: queryString,
      };
      https
        .fetchGet("/releases-house/house-data", param)
        .then((data) => {
          var arrays = [];

          console.log(data.data);
          for (var i = 0; i < data.data.data.length; i++) {
            arrays.push({
              value:
                data.data.data[i].value +
                "-" +
                data.data.data[i].building_no +
                "-" +
                data.data.data[i].room_no,
              id: data.data.data[i].id,
            });
            // console.log(data.data[i].value)
          }
          // console.log(arrays)
          cb(arrays);
        })
        .catch((err) => {
          console.log(err);
        });
      // this.getQuer(queryString)
      // var restaurants = this.restaurants;
      // console.log(restaurants)
      // var results = queryString
      //   ? restaurants.filter(this.createFilter(queryString))
      //   : restaurants;
      // // 调用 callback 返回建议列表的数据
      // console.log(results)
      // cb(results);
    },

    getQuer(quers) {
      var param = {
        keywords: quers,
      };
      console.log(quers);
      https
        .fetchGet("/releases-house/house-data", param)
        .then((data) => {
          this.restaurants = data.data;
          // console.log(data)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createFilter(queryString) {
      // console.log(queryString)
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    handleSelect(item) {
      var param = {
        id: item.id,
      };
      this.$confirm("此操作将刷新该房源", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          https
            .fetchGet("/releases-house/update-time", param)
            .then((data) => {
              this.$message({
                type: "success",
                message: "刷新成功!",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提示框

    // radio选择
    radioChange(e) {
      console.log(e);
    },
    onSubmit() {
      console.log("submit!");
    },

    handleUpload(raw) {
      if (!this.files.includes(raw.file)) {
        this.files.push(raw.file);
      }
    },

    handleRemove(file) {
      const index = this.files.indexOf(file.raw);
      if (index !== -1) {
        this.files.splice(index, 1);
      }
    },

    async submitUpload() {
      var xqnamed = this.form.xqname;
      var lounumberd = this.form.lounumber;
      var haonumberd = this.form.haonumber;
      var regionRoomd = this.form.regionRoom;
      var regionTingd = this.form.regionTing;
      var regionWeid = this.form.regionWei;
      var regionYajingd = this.form.regionYajing;
      var regionZujingd = this.form.regionZujing;
      var radioHouseTyped = this.form.radioHouseType;
      var province = this.form.quyu[0];
      var city = this.form.quyu[1];
      var regional = this.form.quyu[2];
      var rentType = this.form.rentType;
      var subwayd = this.form.lineStation[0];
      var subwaystationd = this.form.lineStation[1];
      var rentd = this.form.rent;
      var rentbaid = this.form.rentbai;
      var jianjied = this.form.jianjie;
      var fdname = this.form.fangdxingming;
      var fdphone = this.form.fangdphone;
      var housesized = this.form.housesize;
      var sheshid = this.form.sheshi;
      var imgurlend = this.form.imgurldata;
      var type = this.form.radio;
      // var userid = sessionStorage.getItem("userid");
      var userid = this.$cookies.get("userid");
      if (!userid) {
        this.$alert("前往登录？", "登陆已过期，请重新登陆", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "cancel") {
              this.$router.push({ path: "/index" });
            } else {
              this.$router.push({ path: "/login" });
            }
          },
        });
        // this.$message.error("登陆已过期，请重新登陆");
        // this.$router.push({ path: "/login" });
        return false;
      }
      var sheshidstring = sheshid.join(",");

      if (xqnamed == "") {
        this.$message.error("请填写小区名称");
        return false;
      }

      if (lounumberd == "") {
        this.$message.error("请填写小区几号楼");
        return false;
      }

      if (haonumberd == "") {
        this.$message.error("请填写小区房间号码");
        return false;
      }

      if (regionRoomd == "") {
        this.$message.error("请选择户型(室)");
        return false;
      }

      if (regionTingd == "") {
        this.$message.error("请选择户型(厅)");
        return false;
      }

      if (regionWeid == "") {
        this.$message.error("请选择户型(卫)");
        return false;
      }

      if (regionYajingd == "") {
        this.$message.error("请选择付款方式（押金）");
        return false;
      }

      if (regionZujingd == "") {
        this.$message.error("请选择付款方式（租金）");
        return false;
      }

      if (radioHouseTyped == "") {
        this.$message.error("请选择房源类型");
        return false;
      }

      if (province == "" || city == "" || regional == "") {
        this.$message.error("请选择所在区域");
        return false;
      }

      if (this.options.length > 0 && (subwayd == "" || subwayd == undefined)) {
        this.$message.error("请选择地铁线");
        return false;
      }

      if (
        this.options.length > 0 &&
        (subwaystationd == "" || subwaystationd == undefined)
      ) {
        this.$message.error("请填写地铁站点");
        return false;
      }

      if (housesized == "") {
        this.$message.error("请输入面积（平方米）");
        return false;
      }

      if (rentd == "") {
        this.$message.error("请填写房屋租金");
        return false;
      }

      if (rentbaid == "") {
        this.$message.error("请填写佣金比例");
        return false;
      }

      if (fdname == "") {
        this.$message.error("请输入房东姓名");
        return false;
      }

      if (fdphone == "") {
        this.$message.error("请输入房东电话");
        return false;
      }

      if (sheshid.length == 0) {
        this.$message.error("请选择房屋设施");
        return false;
      }

      this.$checkPhone(this.form.fangdphone);

      if (this.files == "") {
        this.$message.error("请至少上传一张房子图片");
        return false;
      }

      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
      let fd = new FormData();
      console.log(fd);

      this.files.forEach(function(file) {
        fd.append("UploadForm[file][]", file, file.name); // 因为要上传多个文件，所以需要遍历一下才行
        //不要直接使用我们的文件数组进行上传，你会发现传给后台的是两个Object
      });

      await https
        .fetchPost("/releases-house/upload", fd, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((data) => {
          var imgdata = data.data.img;
          var imgdatad = imgdata.join(",");
          imgurlend = imgdatad;
        })
        .catch((err) => {
          console.log(err);
        });

      // await  this.$refs.upload.submit();
      //  param.imgurl = param.imgurl.join();

      //this.form.imgurldata = Array.from(this.form.imgurldata)
      var param = {
        type_id: radioHouseTyped,
        facilities: sheshidstring,
        village_name: xqnamed,
        room: regionRoomd,
        hall: regionTingd,
        bathrooms: regionWeid,
        rent_type: rentType,
        and: regionYajingd,
        pay: regionZujingd,
        area: this.form.area,
        province: province,
        city: city,
        regional: regional,
        location_address: this.form.location_address,
        subway: subwayd,
        station: subwaystationd,
        // address: addressd,
        rental: rentd,
        commission: rentbaid,
        building_no: lounumberd,
        room_no: haonumberd,
        imgurl: imgurlend,
        user_id: userid,
        landlord_name: fdname,
        landlord_phone: fdphone,
        introduction: jianjied,
        size: housesized,
        type: this.form.radio,
        is_company: this.is_company,
      };
      https
        .fetchPost("/releases-house/releases-house-ajax", qs.stringify(param))
        .then((data) => {
          if (data.data.res_code == 0) {
            this.$message.error("发布失败，请重试");
          } else {
            loading.close();
            //this.$router.push({ path: "/Index" }); //测试
            $("#myModaltwo").modal("show");

            var self = this;
            $("#myModaltwo").on("hide.bs.modal", function() {
              self.$router.push({ path: "/Index" });
            });
            console.log(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style src="../assets/css/bootstrap.min.css" scoped></style>
<style scoped>
.inline-input {
  width: 350px;
}
.el-scrollbar {
  width: 350px;
}
.el-col {
  padding: 5px 0px;
}

.sdf {
  color: #fff;
}

.re-1 {
  width: 70%;
}

.login-container {
  /* 加载背景图 */
  background-image: url(../assets/images/zhiyeindex.jpg);
  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
  background-attachment: fixed;
  /* 让背景图基于容器大小伸缩 */
  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
}

.el-cascader--medium {
  width: 230px;
}

.re-2 {
  width: 50%;
}

.re-2copy {
  width: 50%;
  margin-left: -66px;
}

.re-12 {
  width: 50%;
}

.re-13 {
  width: 100%;
  text-align: left;
}

.re-14 {
  width: 100%;
  text-align: left;
  margin-left: -68px;
}

.re-11 {
  width: 100%;
}

.re-4 {
  width: 100%;
}

.re-5 {
  width: 100%;
  margin-left: -56px;
}

.re-6 {
  width: 100%;
  margin-left: -112px;
}

.re-7 {
  width: 100%;
}

.re-8 {
  width: 100%;
  margin-left: -56px;
}

.re-9 {
  width: 70%;
}

.re-10 {
  margin-left: -66px;
}
</style>
